import React from "react";

const MarketOutlook = () => {
  return (
    <div className="py-8">
      <div className="p-6 bg-white rounded-lg shadow border1 font-inter">
        <div className="">
          {/* Title */}
          <h1 className="text-2xl md:text-3xl font-bold font4 mb-4">
            Global Spatial Genomics & Transcriptomics Market Size & Outlook
          </h1>

          {/* Description */}
          <p className="font14 mb-6 leading-relaxed">
            The spatial genomics & transcriptomics industry worldwide is
            expected to reach a projected revenue of US$ 631.7 million by 2030.
            A compound annual growth rate of 10.7% is expected of the worldwide
            spatial genomics & transcriptomics industry from 2024 to 2030.
          </p>

          {/* Bullet Points */}
          <ul className="list-disc pl-5 space-y-3 font14 mb-4">
            <li>
              The global spatial genomics & transcriptomics market generated a
              revenue of USD 310.0 million in 2023 and is expected to reach USD
              631.7 million by 2030.
            </li>
            <li>
              The market is expected to grow at a CAGR (2024 – 2030) of 10.7% by
              2030.
            </li>
            <li>
              In terms of segment, consumables accounted for a revenue of USD
              163.5 million in 2023.
            </li>
            <li>
              Software is the most lucrative product segment registering the
              fastest growth during the forecast period.
            </li>
            <li>
              In terms of region, North America was the largest revenue
              generating market in 2023.
            </li>
            <li>
              Country-wise, Kuwait is expected to register the highest CAGR from
              2024 to 2030.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MarketOutlook;
